import { useCurrentTenant } from './useCurrentTenant';

export const usePagePermissions = () => {
    const { tenant: currentTenant, loading } = useCurrentTenant();

    const hasPageAccess = (pageId: string): boolean => {
        if (!currentTenant) {
            return false;
        }

        // Si no hay páginas habilitadas configuradas, permitir acceso por defecto (retrocompatibilidad)
        if (!currentTenant.configuracion?.modulosHabilitados) {
            return true;
        }

        const hasAccess = currentTenant.configuracion.modulosHabilitados.includes(pageId);
        return hasAccess;
    };

    const getEnabledPages = (): string[] => {
        if (!currentTenant) return [];
        return currentTenant.configuracion?.modulosHabilitados || [];
    };

    return {
        hasPageAccess,
        getEnabledPages,
        currentTenant,
        // True mientras el tenant se resuelve — permite a los consumidores
        // (p.ej. FacturaForm) mantener semántica de "cargado" sin un hook extra.
        loading,
    };
};
